var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 19.9899C0 9.05405 9.05405 0 19.9899 0C30.9257 0 40 9.05405 40 19.9899C40 30.9459 30.9459 40 20.0101 40C9.07432 40 0 30.9459 0 19.9899ZM36.452 19.9899C36.4543 17.8283 36.03 15.6876 35.2032 13.6904C34.3765 11.6932 33.1637 9.87885 31.6343 8.35135C30.1049 6.82385 28.2891 5.61326 26.2909 4.78899C24.2927 3.96473 22.1514 3.54299 19.9899 3.54797C10.8682 3.54797 3.58919 10.8716 3.58919 19.9899C3.58919 29.1284 10.8919 36.4311 20.0081 36.4311C29.1243 36.4311 36.4723 29.1284 36.452 19.9899ZM17.8236 27.7703C17.8236 26.6149 18.7932 25.6865 19.9899 25.6865C21.1865 25.6865 22.1561 26.5946 22.1561 27.7703C22.1561 28.9257 21.1655 29.8331 19.9899 29.8331C18.8142 29.8331 17.8236 28.9223 17.8236 27.7703ZM18.3784 21.8243L18.1081 11.8189C18.0878 10.7669 18.8514 10.0243 19.9649 10.0243C21.0581 10.0243 21.8628 10.7878 21.8426 11.8399L21.5574 21.8243C21.5372 22.8764 20.9595 23.4331 19.9899 23.4331C18.9791 23.4345 18.4014 22.8777 18.3784 21.8243Z",
    fill: "#2A36AB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/Message.830bc17c05c2ad4fb94a7ed84ca817ab.svg";
export { ForwardRef as ReactComponent };